import { StyleSheet, View } from 'react-native';

import { Skeleton } from '@fhs/ui';

export function PointsRowSkeleton() {
  return (
    <View
      accessible
      accessibilityLabel="Loading rewards points"
      accessibilityRole="progressbar"
      style={styles.container}
    >
      <Skeleton style={styles.skeleton} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    minHeight: 44,
  },
  skeleton: { height: 40, width: 200 },
});
